import { render, staticRenderFns } from "./EditWhyChooseUs.vue?vue&type=template&id=79d4aef2&scoped=true&"
import script from "./EditWhyChooseUs.vue?vue&type=script&lang=js&"
export * from "./EditWhyChooseUs.vue?vue&type=script&lang=js&"
import style0 from "./EditWhyChooseUs.vue?vue&type=style&index=0&id=79d4aef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d4aef2",
  null
  
)

export default component.exports